import { requests } from './agent'
import { HttpResponse } from '../models/http/Reponse'
import { Order, CreateOrder } from '../models/Payments'

interface OrderListResponse extends HttpResponse {
  data: Order[]
}

interface OrderResponse extends HttpResponse {
  data: Order
}

const Payments = {
  list: () => requests.get<OrderListResponse>('/Payment'),
  details: (id: string) => requests.get<OrderResponse>(`/Payment/${id}`),
  editOrderStatus: (id: string, order: { status: number }) =>
    requests.put(`/Payment/${id}/status`, order),
  createOrder: (order: CreateOrder) => requests.post<any>('/Payment', order),
}

export default Payments
